import React from "react";

const InfoSection = () => {
  return (
    <div className="info-section">
      <h2>About Me</h2>
      <p>Name: Mahdi Karami</p>
      <p>Email: mahdi.karami@gmail.com</p>
      <p>Cellphone: (+1) 226-344-7809</p>
      <p>
        LinkedIn:{" "}
        <a href="https://www.linkedin.com/in/mahdikarami">
          https://www.linkedin.com/in/mahdikarami
        </a>
      </p>
    </div>
  );
};

export default InfoSection;
